export default __webpack_public_path__ + "static/media/ic_question.72a4a070.svg";